export default [
    {
      path: '/terms',
      name: 'terms',
      component: () => import('@/views/sft/Terms.vue'),
    },
  ]